module.exports = __webpack_public_path__ + "media/images/countryrect/gq-4b8e7c5b5ee0c7fc84fad53ebf1986ef.svg";